import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export const _6mpIcon = React.forwardRef<HTMLSpanElement, IconProps>((props, ref) => {
    return <Icon {...props} iconKey={"6mp"} ref={ref}/>
});

_6mpIcon.displayName = "_6mpIcon";
